import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StageEHealthDeclaration, Step3FormData } from '../../models/classes/stage-e/E-Service.class';

export interface ApplicationStageEStates {
  stage_e_started_e_service: boolean;
  stage_e_selected_form_sn: string[];
  select_cpf_form_uuid: string[];
  formData: StageEHealthDeclaration;
  step3formData: Step3FormData | null;
}

const initialState: ApplicationStageEStates = {
  stage_e_started_e_service: false,
  stage_e_selected_form_sn: [],
  select_cpf_form_uuid: [],
  formData: new StageEHealthDeclaration(),
  step3formData: null,
};

const ApplicationStageESlice = createSlice({
  name: 'Application Stage E Slice',
  initialState,
  reducers: {
    updateStageEStartEService: (state, action: PayloadAction<boolean>) => {
      state.stage_e_started_e_service = action.payload;
    },

    updateFormData: (state, action: PayloadAction<StageEHealthDeclaration>) => {
      state.formData = action.payload;
      if (action.payload.radio_1.toLowerCase() === 'no') {
        state.formData.input_1 = '';
      }
      if (action.payload.radio_2.toLowerCase() === 'no') {
        state.formData.input_2 = '';
      }
      if (action.payload.radio_3.toLowerCase() === 'no') {
        state.formData.input_3 = '';
      }
    },
    resetFormData: (state) => {
      state.formData = new StageEHealthDeclaration();
    },
    selectedForm: (state, action: PayloadAction<string[]>) => {
      state.stage_e_selected_form_sn = action.payload;
    },
    resetSelectedForm: (state) => {
      state.stage_e_selected_form_sn = [];
    },
    updateSelectCpfFormUuid: (state, action: PayloadAction<string[]>) => {
      state.select_cpf_form_uuid = action.payload;
    },
    resetSelectCpfFormUuid: (state) => {
      state.select_cpf_form_uuid = [];
    },
    updateStep3FormData: (state, action: PayloadAction<Step3FormData>) => {
      state.step3formData = action.payload;
    },
    resetStep3FormData: (state) => {
      state.step3formData = null;
    },
  },
  extraReducers: {},
});

export const {
  updateStageEStartEService,
  updateFormData,
  updateStep3FormData,
  resetFormData,
  selectedForm,
  resetSelectedForm,
  resetStep3FormData,
  updateSelectCpfFormUuid,
  resetSelectCpfFormUuid,
} = ApplicationStageESlice.actions;
export default ApplicationStageESlice.reducer;
